import { render, staticRenderFns } from "./current-batch.vue?vue&type=template&id=54920a91"
import script from "./current-batch.vue?vue&type=script&lang=js"
export * from "./current-batch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports